import React, { useState } from 'react';
import MDBox from 'components/MDBox';
import { makeStyles } from '@mui/styles';
import { TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import MDTypography from 'components/MDTypography';

const DataGridTable = ({ title, rowData, columns, selectedRows, setSelectedRows }) => {
    const useStyles = makeStyles({
        root: {
            '& .MuiDataGrid-row.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 255, 0.3)', // Customize selected row background color
            },
            '& .MuiDataGrid-row.Mui-selected:hover': {
                backgroundColor: 'rgba(0, 0, 255, 0.3)', // Keep the same background color on hover
            },
            '& .MuiDataGrid-row:hover': {
                backgroundColor: 'rgba(0, 0, 255, 0.04)', // Customize background color on hover
            },
            '& .MuiDataGrid-cell:focus-within': {
                outline: 'none', // Remove outline on cell focus
            },
        },
    });
    const classes = useStyles();

    const [searchQuery, setSearchQuery] = useState('');

    const filteredRows = rowData.filter((row) => {
        const searchLower = searchQuery.toLowerCase();

        return Object.values(row).some((cellValue) => {
            // If the value is an object (not null or array), try to flatten it
            if (typeof cellValue === 'object' && cellValue !== null && !Array.isArray(cellValue)) {
                try {
                    cellValue = Object.values(cellValue)
                        .filter(v => typeof v !== 'symbol') // Filter out Symbols
                        .join(' ');
                } catch (e) {
                    return false; // Skip this cell if any error occurs
                }
            }

            // If value is a symbol or something invalid, skip it
            if (typeof cellValue === 'symbol') return false;

            return (
                cellValue &&
                typeof cellValue === 'string' &&
                cellValue.toLowerCase().includes(searchLower)
            );
        });
    });

    //   const columns = [
    //     {
    //       field: "address_item_id",
    //       accessor: "address_item_id",
    //       headerName: "Entity Address Item ID",
    //       Header: "Entity Address Item ID",
    //       flex: 1,
    //     },
    //     {
    //       field: "Icon.icon_name",
    //       accessor: "Icon.icon_name",
    //       headerName: "Icon",
    //       Header: "Icon",
    //       flex: 0.5,
    //       width: 50,
    //       renderCell: (info) => {
    //         return <i className={`${info.row.Icon?.class_name}`} style={{ fontSize: "24px" }}></i> 
    //       },
    //     },
    //     {
    //       field: "name",
    //       accessor: "name",
    //       headerName: "Item Name",
    //       Header: "Item Name",
    //       flex: 1,
    //       valueGetter: (params) => params.row?.name,
    //     },
    //     {
    //       field: "Item.name",
    //       accessor: "Item.name",
    //       headerName: "Item Type Name",
    //       Header: "Item Type Name",
    //       flex: 1,
    //       valueGetter: (params) => params.row.Item?.name,
    //     },
    //     {
    //       field: "Entity.name",
    //       accessor: "Entity.name",
    //       headerName: "Entity Name",
    //       Header: "Entity Name",
    //       flex: 1,
    //       renderCell: (info) => {
    //         const entityName = info.row.Entity?.name;
    //         const firstName = info.row.Entity?.first_name;
    //         const lasttName = info.row.Entity?.last_name;
    //         // Check if Entity.name is empty or null, then use first_name
    //         return !["", null, undefined].includes(entityName) ? entityName : firstName + " " + lasttName;
    //       },
    //     },
    //     {
    //       field: "Address.name",
    //       accessor: "Address.name",
    //       headerName: "Address Name",
    //       Header: "Address Name",
    //       flex: 1,
    //       valueGetter: (params) => params.row.Address?.name,
    //     },
    //     {
    //       field: "Address.street_address1",
    //       accessor: "Address.street_address1",
    //       headerName: "Street Address",
    //       Header: "Street Address",
    //       flex: 1.2,
    //       valueGetter: (params) => params.row.Address?.street_address1,
    //     },
    //     {
    //       field: "Address.city",
    //       accessor: "Address.city",
    //       headerName: "City",
    //       Header: "City",
    //       flex: 1,
    //       valueGetter: (params) => params.row.Address?.city,
    //     },
    //     {
    //       field: "Address.state",
    //       accessor: "Address.state",
    //       headerName: "State",
    //       Header: "State",
    //       flex: 1,
    //       valueGetter: (params) => params.row.Address?.state,
    //     },
    //   ];

    return (
        <MDBox display="flex" flexDirection="column">
            <MDBox display="flex" mb={1} alignItems="center" justifyContent="space-between">
                <MDTypography>{title}</MDTypography>
                <MDBox display="flex" justifyContent="right" alignItems="right">
                    <TextField
                        label="Search"
                        variant="outlined"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </MDBox>
            </MDBox>
            <DataGrid
                className={classes.root}
                rows={filteredRows}
                columns={columns}
                disableColumnFilter
                onRowSelectionModelChange={(value) => setSelectedRows(value)}
                rowSelectionModel={selectedRows}
                getRowId={(row) => row.id}
                sx={{
                    maxHeight: '70vh', // Limit the modal height to 80% of viewport height
                    color: '#fff'
                }}
                checkboxSelection
                disableRowSelectionOnClick
            />
        </MDBox>
    );
};

export default DataGridTable;
